import { formatTimeToPtBr } from '@/utils/helpers/dateTimeHelper'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export const getGenderFormated = (gender?: string) => {
  if (gender === 'F') {
    return 'Feminino'
  }

  if (gender === 'M') {
    return 'Masculino'
  }

  return ''
}

export const getShift = (date: Date | null): string => {
  if (!date) {
    return ''
  }

  const hour = date.getHours()

  if (hour < 12) return 'Manhã'
  if (hour < 18) return 'Tarde'
  return 'Noite'
}

export const getFormatedHours = (date: Date | null): string => {
  if (!date) {
    return ''
  }

  return `${formatTimeToPtBr(date)} - ${getShift(date)}`
}

export const getFormatedStartDate = (date: Date | null): string => {
  if (!date) {
    return ''
  }

  const formatedDate = format(date, "eeee, dd 'de' MMMM", { locale: ptBR })
  const capitalize = formatedDate.charAt(0).toLocaleUpperCase()

  return capitalize + formatedDate.slice(1)
}

export const getFormatedPrice = (price: number | null | undefined): string => {
  if (!price) {
    return ''
  }

  return price.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
}
